import { GrappleModule } from "../interfaces/api/GrappleModule";
import { LowerBracket } from "../interfaces/api/LowerBracket";
import { MachineFixing } from "../interfaces/api/MachineFixing";
import { Rototilt } from "../interfaces/api/Rototilt";
import { UpperBracket } from "../interfaces/api/UpperBracket";
import { MachineFixingType } from "../shared/enums/MachineFixingType";
import { ProductCategory } from "../shared/enums/ProductCategory";
import { ProductType } from "../shared/enums/ProductType";
import { ProductItem } from "../shared/types/ProductItem";
import { ActionType } from "./ActionType";
import { ContactUsFormValues } from "./interfaces/ContactUsFormValues";
import { MachineTonnage } from "./interfaces/MachineTonnage";
import { Wizard } from "./interfaces/Wizard";

const saveMarket = (market: string) => {
  return { type: ActionType.SAVE_MARKET, data: market };
};

const saveFlagMarket = (flagMarket: string) => {
  return { type: ActionType.SAVE_FLAG_MARKET, data: flagMarket };
};

const saveWizard = (wizard: Wizard) => {
  return { type: ActionType.SAVE_WIZARD, data: wizard };
};

const saveWizardEnableNext = (enableNext: boolean) => {
  return { type: ActionType.SAVE_WIZARD_ENABLE_NEXT, data: enableNext };
};

const saveMachineTonnage = (machineTonnage: MachineTonnage) => {
  return { type: ActionType.SAVE_MACHINE_TONNAGE, data: machineTonnage };
};

const saveProductCategory = (productCategory: ProductCategory) => {
  return { type: ActionType.SAVE_PRODUCT_CATEGORY, data: productCategory };
};

const saveProductMachineFixingType = (machineFixingType: MachineFixingType) => {
  return {
    type: ActionType.SAVE_PRODUCT_MACHINE_FIXING_TYPE,
    data: machineFixingType,
  };
};

const saveProductToolsProductTypes = (toolsProductTypes: ProductType[]) => {
  return {
    type: ActionType.SAVE_PRODUCT_TOOLS_PRODUCT_TYPES,
    data: toolsProductTypes,
  };
};

const saveOptionalToolsProductTypes = (toolsProductTypes: ProductType[]) => {
  return {
    type: ActionType.SAVE_OPTIONAL_TOOLS_PRODUCT_TYPES,
    data: toolsProductTypes,
  };
};

const saveOptionalToolsIsToolsSelected = (isToolsSelected: boolean) => {
  return {
    type: ActionType.SAVE_OPTIONAL_TOOLS_IS_TOOLS_SELECTED,
    data: isToolsSelected,
  };
};

const saveOptionalToolsIsTiltrotatorsSelected = (
  isTiltrotatorsSelected: boolean
) => {
  return {
    type: ActionType.SAVE_OPTIONAL_TOOLS_IS_TILTROTATORS_SELECTED,
    data: isTiltrotatorsSelected,
  };
};

const saveOptionalToolsIsMachineFixingsSelected = (
  isMachineFixingsSelected: boolean
) => {
  return {
    type: ActionType.SAVE_OPTIONAL_TOOLS_IS_MACHINE_FIXINGS_SELECTED,
    data: isMachineFixingsSelected,
  };
};

const saveOptionalMachineFixingType = (
  machineFixingType: MachineFixingType
) => {
  return {
    type: ActionType.SAVE_OPTIONAL_MACHINE_FIXING_TYPE,
    data: machineFixingType,
  };
};

const saveCartSelectionsProductTiltrotator = (tiltrotator: Rototilt) => {
  return {
    type: ActionType.SAVE_CART_SELECTIONS_PRODUCT_TILTROTATOR,
    data: tiltrotator,
  };
};

const saveCartSelectionsProductMachineFixing = (
  machineFixing: MachineFixing
) => {
  return {
    type: ActionType.SAVE_CART_SELECTIONS_PRODUCT_MACHINE_FIXING,
    data: machineFixing,
  };
};

const saveCartSelectionsProductUpperBracket = (upperBracket: UpperBracket) => {
  return {
    type: ActionType.SAVE_CART_SELECTIONS_PRODUCT_UPPER_BRACKET,
    data: upperBracket,
  };
};

const saveCartSelectionsProductLowerBracket = (lowerBracket: LowerBracket) => {
  return {
    type: ActionType.SAVE_CART_SELECTIONS_PRODUCT_LOWER_BRACKET,
    data: lowerBracket,
  };
};

const saveCartSelectionsProductGrappleModule = (
  grappleModule: GrappleModule
) => {
  return {
    type: ActionType.SAVE_CART_SELECTIONS_PRODUCT_GRAPPLE_MODULE,
    data: grappleModule,
  };
};

const saveCartSelectionsProductNoGrappleModuleSelected = (
  isNoneGrappleModuleSelected: boolean
) => {
  return {
    type: ActionType.SAVE_CART_SELECTIONS_PRODUCT_NO_GRAPPLE_MODULE_SELECTED,
    data: isNoneGrappleModuleSelected,
  };
};

const saveCartSelectionsProductToolsProductItems = (
  toolsProductItems: ProductItem[]
) => {
  return {
    type: ActionType.SAVE_CART_SELECTIONS_PRODUCT_TOOLS_PRODUCT_ITEMS,
    data: toolsProductItems,
  };
};

const saveCartSelectionsOptionalToolsProductItems = (
  toolsProductItems: ProductItem[]
) => {
  return {
    type: ActionType.SAVE_CART_SELECTIONS_OPTIONAL_TOOLS_PRODUCT_ITEMS,
    data: toolsProductItems,
  };
};

const saveCartSelectionsOptionalTiltrotator = (tiltrotator: Rototilt) => {
  return {
    type: ActionType.SAVE_CART_SELECTIONS_OPTIONAL_TILTROTATOR,
    data: tiltrotator,
  };
};

const saveCartSelectionsOptionalMachineFixing = (
  machineFixing: MachineFixing
) => {
  return {
    type: ActionType.SAVE_CART_SELECTIONS_OPTIONAL_MACHINE_FIXING,
    data: machineFixing,
  };
};

const saveCartSelectionsOptionalGrappleModule = (
  grappleModule: GrappleModule
) => {
  return {
    type: ActionType.SAVE_CART_SELECTIONS_OPTIONAL_GRAPPLE_MODULE,
    data: grappleModule,
  };
};

const saveCartSelectionsOptionalNoGrappleModuleSelected = (
  isNoneGrappleModuleSelected: boolean
) => {
  return {
    type: ActionType.SAVE_CART_SELECTIONS_OPTIONAL_NO_GRAPPLE_MODULE_SELECTED,
    data: isNoneGrappleModuleSelected,
  };
};

const saveCartOptionalToolsProductItems = (
  toolsProductItems: ProductItem[]
) => {
  return {
    type: ActionType.SAVE_CART_OPTIONAL_TOOLS_PRODUCT_ITEMS,
    data: toolsProductItems,
  };
};

const saveContactUsForm = (contactUsFormValues: ContactUsFormValues) => {
  return {
    type: ActionType.SAVE_CONTACT_US_FORM,
    data: contactUsFormValues,
  };
};

const saveIsLoadedFromSummary = (isLoadedFromSummary: boolean) => {
  return {
    type: ActionType.SAVE_IS_LOADED_FROM_SUMMARY,
    data: isLoadedFromSummary,
  };
};

const moveCartProductSelectionsToCart = () => {
  return { type: ActionType.MOVE_CART_PRODUCT_SELECTIONS_TO_CART, undefined };
};

const moveCartOptionalSelectionsToCart = () => {
  return { type: ActionType.MOVE_CART_OPTIONAL_SELECTIONS_TO_CART, undefined };
};

const copyCartProductToCartProductSelections = () => {
  return {
    type: ActionType.COPY_CART_PRODUCT_TO_CART_PRODUCT_SELECTIONS,
    undefined,
  };
};

const copyCartOptionalToCartOptionalSelections = () => {
  return {
    type: ActionType.COPY_CART_OPTIONAL_TO_CART_OPTIONAL_SELECTIONS,
    undefined,
  };
};

const restoreStateFromSummary = (storeStateNew) => {
  return { type: ActionType.RESTORE_STATE_FROM_SUMMARY, data: storeStateNew };
};

const clearCart = () => {
  return { type: ActionType.CLEAR_CART, undefined };
};

const clearCartSelections = () => {
  return { type: ActionType.CLEAR_CART_SELECTIONS, undefined };
};

const saveProducts = (data) => {
  return { type: ActionType.PRODUCTS_SAVE_DATA, data };
};

const saveEpiLink = (epiLink) => {
  return { type: ActionType.SAVE_EPISERVER_URLS, data: epiLink };
};

export const action = {
  saveMarket,
  saveFlagMarket,
  saveWizard,
  saveWizardEnableNext,
  saveMachineTonnage,
  saveProductCategory,
  saveProductMachineFixingType,
  saveProductToolsProductTypes,
  saveOptionalToolsProductTypes,
  saveOptionalToolsIsToolsSelected,
  saveOptionalToolsIsTiltrotatorsSelected,
  saveOptionalToolsIsMachineFixingsSelected,
  saveOptionalMachineFixingType,
  saveCartSelectionsProductTiltrotator,
  saveCartSelectionsProductMachineFixing,
  saveCartSelectionsProductUpperBracket,
  saveCartSelectionsProductLowerBracket,
  saveCartSelectionsProductGrappleModule,
  saveCartSelectionsProductNoGrappleModuleSelected,
  saveCartSelectionsProductToolsProductItems,
  saveCartSelectionsOptionalToolsProductItems,
  saveCartSelectionsOptionalTiltrotator,
  saveCartSelectionsOptionalMachineFixing,
  saveCartSelectionsOptionalGrappleModule,
  saveCartSelectionsOptionalNoGrappleModuleSelected,
  saveCartOptionalToolsProductItems,
  saveContactUsForm,
  saveIsLoadedFromSummary,
  moveCartProductSelectionsToCart,
  moveCartOptionalSelectionsToCart,
  copyCartProductToCartProductSelections,
  copyCartOptionalToCartOptionalSelections,
  restoreStateFromSummary,
  clearCart,
  clearCartSelections,
  saveProducts,
  saveEpiLink,
};
